import * as React from 'react'
import PropTypes from 'prop-types'
import { PopoverClose } from '../../../internal/components/PopoverClose'
import type { ButtonOnClickHandler } from '../../../types'

export interface ModalCloseProps {
  /**
   * Indicates the close button is sitting on a dark background.
   */
  dark?: boolean
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * The function to call when a 'click' event is fired.
   */
  onClick?: ButtonOnClickHandler
}

export function ModalClose({ dark = false, ...restProps }: ModalCloseProps) {
  return <PopoverClose {...restProps} dark={dark} scrim />
}

ModalClose.propTypes = {
  dark: PropTypes.bool,
  'data-.*': PropTypes.string,
  onClick: PropTypes.func,
}

ModalClose.displayName = 'Modal.Close'
